import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  min-width: 0;
  @media (max-width: 767px) {
    flex-direction: column;
  }

  .leftSide {
    width: 230px;
    font-weight: 400;
    font-size: 12px;
    line-height: 130%;
    color: var(--color-text-subtle);
    flex: 0 0 auto;

    h3 {
      margin: 0;
      font-weight: 600;
      font-size: 12px;
      line-height: 150%;
      color: var(--color-text-muted);
      padding: 0 0 10px;
    }
  }

  .rightSide {
    min-width: 0;
    width: 100%;

    .rightSide-columns {
      display: flex;
      gap: 10px;
      flex-wrap: wrap;

      .rightSide-first-row {
        display: flex;
        width: 100%;
        gap: 20px;
        flex-wrap: wrap;
        padding: 0 0 5px;
      }
    }
  }

  .input-wrapper {
    position: relative;
    width: 280px;
    max-width: 100%;
    flex: 0 0 auto;

    label {
      font-weight: 500;
      font-size: 12px;
      line-height: 20px;
      color: var(--color-text-muted);
    }
  }

  .checkbox-wrapper {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 11px;
    line-height: 100%;
    color: var(--color-text-muted);
    margin: 10px 0;
  }

  .messages-row-wrapper {
    width: 100%;
    .error-message {
      color: var(--color-danger);
      font-weight: 500;
      text-align: center;
      line-height: 100%;
      padding: 0 0 20px;
    }
    .info-message {
      color: var(--color-text-muted);
      text-align: left;
      padding: 0 0 20px;
    }
  }

  .save-wrapper {
    display: flex;
    justify-content: end;
    padding: 0 0 20px;
  }
`;
